export default {
  props: {
    /**
    * Pointer, used when interface powers a traversable doc using JsonPointer
    */
    pointer: {type: String, default: null}
  },
  methods: {
    propagatePointer() {
      this.$parent.$emit('pointer:updated', this.pointer);
    }
  }
};
